import {
  RecordProps,
  TLBaseShape,
  TLDrawShapeSegment,
  vecModelValidator,
} from "tldraw"
import { T } from "@tldraw/validate"
import { Color, Expr } from "./Expr"

export type MarkerShapeProps = {
  color: Expr<Color>
  radius: number
  segments: TLDrawShapeSegment[]
  isComplete: boolean
  isPen: boolean
  scale: number
  layer: string
}

export type MarkerShape = Omit<
  TLBaseShape<"marker-shape", MarkerShapeProps>,
  "meta"
> & { meta: {} }

/** @public */
export const DrawShapeSegment: T.ObjectValidator<TLDrawShapeSegment> = T.object(
  {
    type: T.literalEnum("free", "straight"),
    points: T.arrayOf(vecModelValidator),
  },
)

/** @public */
export const markerShapeProps: RecordProps<MarkerShape> = {
  color: T.any,
  radius: T.nonZeroNumber,
  segments: T.arrayOf(DrawShapeSegment),
  isComplete: T.boolean,
  isPen: T.boolean,
  scale: T.nonZeroNumber,
  layer: T.string,
}
